<div class="resize-marker-container" [style.top]="reportLine.top" [style.left]="reportLine.left" [style.width]="reportLine.width"
  [style.height]="reportLine.height" [ngClass]="{'draw-custom-element':isCustomDrawEnable || reportLine.isCustomElement()}">

  <div *ngIf="reportLine.isSelected" class="resize LM" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
    [style.top]="getResizeMarkerTop('middle')" [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportLine.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'middle', 'left')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
    (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportLine.isSelected" class="resize RM" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
    [style.top]="getResizeMarkerTop('middle')" [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportLine.zIndex + 1"
    (mousedown)="onResizeMarkerDown($event, 'middle', 'right')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
    (mouseleave)="onResizeMarkerLeave($event)"></div>
</div>

<div [ngClass]="{
    'report-line': true,
    'selectable': reportLine.isSelectable,
    'selected': reportLine.isSelected,
    'edited': !reportLine.isSaved(),
    'highlight-hover' : designService.highlightElement,
    'draw-custom-element':isCustomDrawEnable || reportLine.isCustomElement()
  }"
  [style.top]="reportLine.top" [style.left]="reportLine.left" [style.width]="reportLine.width" [style.height]="reportLine.height"
  [style.zIndex]="reportLine.zIndex" [style.borderTopStyle]="reportLine.borderTopStyle" [style.borderTopColor]="reportLine.borderTopColor"
  [style.borderLeftStyle]="reportLine.borderLeftStyle" [style.borderLeftColor]="reportLine.borderLeftColor" (click)="onClick($event)"
  draggable="true" (dragstart)="onDragStart($event)" (dragover)="onDragOver($event)" (drop)="onDrop($event)"></div>